import axios from './axiosInstances/axiosInstance';

export const createBasketFromFave = (faveId) => {
  return axios.post(`baskets/fromFave`, {
    faveId,
    ignoreUnavailableProducts: true,
  });
};
